var DEFAULT_COMPRESSION = 'automatic';
var COMPRESSION_OPTIONS = [
  { value: 'automatic', label: 'Automatic (recommended)' },
  { value: 'gzip', label: 'Gzip' },
  { value: 'none', label: 'None' }
];

function normalizeCompression(value) {
  var normalized = String(value || DEFAULT_COMPRESSION).trim().toLowerCase();
  return COMPRESSION_OPTIONS.some(function (option) { return option.value === normalized; })
    ? normalized
    : DEFAULT_COMPRESSION;
}

function normalizeConfig(value) {
  if (typeof value === 'string') {
    try {
      value = JSON.parse(value);
    } catch (e) {
      value = null;
    }
  }
  if (!value || typeof value !== 'object' || Number(value.version) !== 1) {
    return { configured: false, compression: DEFAULT_COMPRESSION, datasets: [] };
  }
  return {
    configured: true,
    compression: normalizeCompression(value.compression),
    datasets: Array.isArray(value.datasets) ? value.datasets : []
  };
}

function buildSavedConfig(groups, selection, compression) {
  return {
    version: 1,
    compression: normalizeCompression(compression),
    datasets: groups.map(function (group) {
      var selected = selection.get(group.schemaKey) || new Set();
      if (!selected.size) return null;
      return {
        schemaKey: group.schemaKey,
        className: group.className,
        componentDepth: group.componentDepth,
        groupKey: group.groupKey,
        datasetName: group.datasetName,
        columns: group.columns.map(function (column) { return column.name; }).filter(function (name) {
          return selected.has(name);
        })
      };
    }).filter(Boolean)
  };
}

module.exports = {
  COMPRESSION_OPTIONS: COMPRESSION_OPTIONS,
  normalizeCompression: normalizeCompression,
  normalizeConfig: normalizeConfig,
  buildSavedConfig: buildSavedConfig
};
